import React from "react";
import "./BrandSection.css";
import loanwalleLogo from "../../images/loanwalle_logo_blue_bg.png";
import quaLogo from "../../images/quabrandlogo.png";
import salarywalleLogo from "../../images/salarywalle.svg";
import zeptoLogo from "../../images/zeptologo.png";

const BrandSection = () => {
  return (
    <section className="brand-section">
      <div className="brand-container">
        <h2 className="brand-title">Our Partners</h2>
        <p className="brand-subtitle">Trusted financial solutions across multiple platforms</p>
        <div className="brand-grid">
          <div className="brand-card">
            <div className="brand-logo-wrapper">
              <img src={loanwalleLogo} alt="Loanwalle" className="brand-logo" />
            </div>
            <h3 className="brand-name">Loanwalle</h3>
          </div>
          <div className="brand-card">
            <div className="brand-logo-wrapper">
              <img src={salarywalleLogo} alt="Salarywalle" className="brand-logo" />
            </div>
            <h3 className="brand-name">Salarywalle</h3>
          </div>
          <div className="brand-card">
            <div className="brand-logo-wrapper">
              <img src={quaLogo} alt="Qua" className="brand-logo" />
            </div>
            <h3 className="brand-name">Qua</h3>
          </div>
          <div className="brand-card">
            <div className="brand-logo-wrapper">
              <img src={zeptoLogo} alt="Zepto" className="brand-logo" />
            </div>
            <h3 className="brand-name">Zepto Finance</h3>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandSection;


